import { ActionBasic } from 'kts-scaffold-framework/modules';
import { webToken, company, appStore } from 'kts-platform-frame/api';
import { login, passwordRule } from 'src/api';
import ModulesState from './Modules.State';
import { MyStore, reducers, Verification } from 'kts-platform-frame/redux';
import { history } from 'kts-platform-frame/routes';
import { message } from 'antd';
import { passConfig } from 'kts-platform-frame/utils';
import TotalModulesAction from '../Modules.Action';

class ModulesAction extends ActionBasic<ModulesState> {

    /**
     * 用户登录
     * @param username 用户名
     * @param password 密码
     */
    public login = async (username: string, password: string) => {

        Verification.instance.stop();

        // 获取token
        const loginData = await webToken.login(this, { identifier: username, credential: password });
        
        if(loginData.er){
            Verification.instance.start();
            return loginData;
        }

        // 获取用户数据
        const userInfoData = await company.userInfo(this);
        if(userInfoData.er){
            Verification.instance.start();
            return userInfoData;
        }

        /** 去除当前登录用户的新手体验提示查看状态 */
        this.setGuideTipState();
        
        Verification.instance.start();
        return loginData;
    }

    /** 登出用户 */
    // public unlogin = () => {
    //     MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
    // }

    /** 更新公司列表 */
    // public updateCompanyList = async () => {
    //     company.list(this, {});
    // }

    /** 切换忘记密码弹窗，显示状态 */
    public switchModalForget = () => {
        this.modulesState.isModalForget = !this.modulesState.isModalForget;
        this.modulesState.sendForgetResult = undefined;
        this.setModulesState(this.modulesState);
    }

    /**
     * 忘记密码弹窗，发送邮件
     */
    public forgetSend = async (email: string, domain: string ) => {
        // 发送邮件
        const data = await login.forgetPwd(this, { "email": email, "domain": domain });  
        if(data.er){
            return false;
        }
        return true;
    }

    /** 忘记密码进入，验证 ticket */
    public resetForgetPswCheck = async (ticket: string) => {
        // 验证 ticket
        const data = await login.resetVerify(this, { "ticket": ticket });
        if(data.er){
            return false;
        }

        this.modulesState.email = data.res.email;
        this.passConfigGetByEmail(data.res.email);
        this.setModulesState(this.modulesState);
        return true;
    }
    /** 设置密码 */
    public activePwd = async (pwd: string) => {
        const params = {
            newPassword: pwd,
            ticket: this.modulesState.ticket
        };
        // 设置密码
        const data = await login.loginactivepwd(this, params);
        if(data.er){
            message.error('该链接已失效,3秒后跳转到登录页面');

            setTimeout(() => {
                MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
                history.push(`/`);
            }, 3000);
            return false;
        }
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
        history.push('/login');
        return true;
    }

    /** 忘记密码进入，重置密码 */
    public resetForgetPswDo = async (pwd: string) => {
        // api 参数
        const params = {
            newPassword: pwd,
            ticket: this.modulesState.ticket
        };
        // 重置密码
        const data = await login.resetPwdDo(this, params);
        if(data.er){
            message.error('该链接已失效,3秒后跳转到登录页面');

            setTimeout(() => {
                MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
                history.push(`/`);
            }, 3000);

            return false;
        } 

        this.modulesState.isSetSuccess = true;
        
        this.setModulesState(this.modulesState);
        return true;
    }

    /** 邀请登录设置密码，验证 ticket */
    public inviteSetPswCheck = async (ticket: string) => {
        // 验证 ticket
        const data = await login.inviteVerify(this, {ticket: ticket });
        if(data.er){
            message.error('该链接已失效,3秒后跳转到登录页面');
                setTimeout(() => {
                MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
                history.push(`/`);
            }, 3000);
            return false;
        } 

        this.modulesState.email = data.res.email;
        this.modulesState.ticketinfo = data.res;
        if (data.res.existed === false) { // 如果exist为false 就直接联系管理员 
            history.push('/login/connectadmin');
        }
        if (data.res.activated) { // 然后 如果activate为true 就直接跳转加入公司页面 flase就需要设置密码再加入公司
            history.push('/login/joincompany');
        } else {
            const passConfigArr =  passConfig(data.res.passConf, '');
            this.modulesState.passConfig = data.res.passConf;
            let str = '';
            this.changePassConfigArr(passConfigArr);
            passConfigArr.forEach(ele => {
                str += ele['message'] + ',';
            });
            str = str.slice(0, str.length - 1);
            this.modulesState.newPasTipMessage = str;
        }
        this.setModulesState();
        return true;
    }
    /** 接受邀请，加入公司 */
    public joinconpany = async (params: any) => {
        
        const data = await login.logincompany(this, params);
        if(data.er){ 
            const description = JSON.parse(JSON.stringify(data.er.body.status.description));
            message.error(description);
            return false;
        }

        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
        history.push(`/`);
    }

    public passConfigGetByEmail = async (email) => {
        const res = await passwordRule.passConfigGetByEmail(this, { email });
        if (!res.er) {
            let str = '';
            this.modulesState.passConfig = res.res;
            const passConfigArr = passConfig(res.res, '');
            this.changePassConfigArr(passConfigArr);
            passConfigArr.forEach(ele => {
                str += ele['message'] + ',';
            });
            str = str.slice(0, str.length - 1);
            this.modulesState.newPasTipMessage = str;
            this.setModulesState();
        }
    }

    public changeNewPasTipView = (b) => {
        this.modulesState.newPasTipView = b;
        this.setModulesState();
    }

    public changePassConfigArr = (option) => {
        this.modulesState.passConfigArr = option;
        this.setModulesState();
    }

    public changePassConfigArrView = (b) => {
        this.modulesState.passConcigArrView = b;
        this.setModulesState();
    }

    public changeNewPasTipMessage = (str) => {
        this.modulesState.newPasTipMessage = str;
        this.setModulesState();
    }

    public updatePasswordCompliance = b => {
        this.modulesState.passwordCompliance = b;
        this.setModulesState();
    }

    public updateLoginEmail = email => {
        this.modulesState.loginEmail = email;
        this.setModulesState();
    }

    public updateConfirmDirty = () => {
        this.modulesState.confirmDirty = true;
        this.setModulesState();
    }

    /** 去除当前登录用户新手引导查看状态 */
    public setGuideTipState = () => {
        const guideVersionUser = JSON.parse(sessionStorage.getItem("guideVersionUser"));
        const { user } = MyStore.instance.getState();  
        if(guideVersionUser && guideVersionUser[user.userInfo.gUserId]){
            delete guideVersionUser[user.userInfo.gUserId];
        }
        sessionStorage.setItem("guideVersionUser", JSON.stringify(guideVersionUser));
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/Modules.Action.ts